import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';

interface PlaceholderComponentProps {
    backgroundColor?: string;
    children?: React.ReactNode;
    isAnimated?: boolean;
}

const PlaceholderComponent: FC<PlaceholderComponentProps> = (props) => {
    const { children, backgroundColor, isAnimated = false } = props;
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: 'inherit',
                backgroundColor: backgroundColor ?? theme.palette.boddBlack.main,
            }}
            data-testid="image-loading-component"
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    '@keyframes blink': {
                        '0%': {
                            opacity: 1,
                        },
                        '50%': {
                            opacity: 0.2,
                        },
                        '100%': {
                            opacity: 1,
                        },
                    },
                    animation: isAnimated ? 'blink 1.2s infinite ease-in-out' : 'none',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

PlaceholderComponent.defaultProps = {
    isAnimated: false,
    backgroundColor: undefined,
    children: undefined,
};

export default PlaceholderComponent;
